import {FaceDto, OrderDto} from "@hec/api-dtos";

export const getSouthFaceFromOrder = (order: OrderDto): FaceDto | null => {
  return order?.faceConfiguration?.faces?.find((face: FaceDto) => face.side === 2) ?? null
}
// faceConfiguration.width
